import { render, staticRenderFns } from "./TeacherRequestDetails.vue?vue&type=template&id=d0daa650&scoped=true"
import script from "./TeacherRequestDetails.vue?vue&type=script&lang=js"
export * from "./TeacherRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./TeacherRequestDetails.vue?vue&type=style&index=0&id=d0daa650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0daa650",
  null
  
)

export default component.exports